import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessTaskStatusesEnum } from '@thinknet-gmbh/platform-common';

import {
  Typography,
  PLATFORM_THEME_COLORS,
  Table,
  Icon,
  ICONS,
} from '@thinknet-gmbh/platform-common-ui';

import { DraggableTable } from '../draggable-table';
import { AssignToDetails } from './components/assign-to-details';
import { ProcessTasksTableRowActions } from './components/process-tasks-table-row-actions';

import { IProcessTemplateItemTask } from '../../pages/settings/components/process-templates/components/process-templates-table/process-templates-table.interfaces';
import { ITaskTableItem } from '../../pages/tasks-manager/sub-pages/task-list/components/tasks-list-table/tasks-list-table.interfaces';

const getTaskStatusClass = ({ status, overdue }: ITaskTableItem, attr: any) => {
  const newAttr = { ...attr };

  if (status === ProcessTaskStatusesEnum.OPEN && !overdue) {
    newAttr.className = 'task-lightYellow';
    return newAttr;
  }

  if (status === ProcessTaskStatusesEnum.OPEN && overdue) {
    newAttr.className = 'task-lightRed';
    return newAttr;
  }

  if (status === ProcessTaskStatusesEnum.COMPLETED) {
    newAttr.className = 'task-lightGreen';
    return newAttr;
  }

  return newAttr;
};

const ProcessTasksTable = ({
  taskList,
  setTaskList,
  handleModals,
  emptyTitle,
}: {
  handleModals: (modal: string, record: IProcessTemplateItemTask) => void;
  taskList: IProcessTemplateItemTask[];
  setTaskList: Dispatch<SetStateAction<any>>;
  emptyTitle?: string;
}) => {
  const { t } = useTranslation('settings');
  return (
    <DraggableTable
      data={taskList}
      setData={setTaskList}
      t={t}
      onRowUpdateAttr={getTaskStatusClass}
      emptyTitle={emptyTitle}
    >
      <Table.Column
        dataIndex={'title'}
        title={t('processBuilder:tasks.labels.title')}
        render={name => (
          <Typography>
            <Icon icon={ICONS.gridVertical} size={20} color={PLATFORM_THEME_COLORS.primary.grey} />
            {name}
          </Typography>
        )}
      />
      <Table.Column
        title={t('processBuilder:tasks.labels.assignedTo')}
        render={({ assignTo }) => {
          return (
            <Typography>
              {t(`processBuilder:tasks.assignToOptions.${assignTo?.toLowerCase()}`)}
            </Typography>
          );
        }}
      />

      <Table.Column
        title={t('processBuilder:tasks.labels.assignedToDetails')}
        render={record => {
          return <AssignToDetails {...record} />;
        }}
      />
      <Table.Column
        width={50}
        title={t('common:labels.action')}
        render={record => {
          return <ProcessTasksTableRowActions record={record} handleModals={handleModals} t={t} />;
        }}
      />
    </DraggableTable>
  );
};

export default ProcessTasksTable;
